import makeValidationSchema from './PersonDocumentDTOMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React, {useCallback} from 'react'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import Grid from '@material-ui/core/Grid'
import { useFormContext, useWatch } from "react-hook-form";
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  form: {
    field: {
      CngTextField,
      CngDateField,
      CngCodeMasterAutocompleteField,
      CngCountryAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  documentType: "",
  issuingCountry: "",
  documentNumber: "",
  expiryDate: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  // makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  index,
  personIndex,
  personDocumentDTO
}) {

  const { setValue } = useFormContext();
  // const { documentType } = useWatch()
  
  const getFieldName = useCallback((field) => {
    return typeof index === 'number' ? `personDTO.${personIndex}.personDocumentDTO.${index}.${field}` : field
  }, [])
  
  const documentType = useWatch({ name: getFieldName('documentType') });
  const issuingCountry = useWatch({ name: getFieldName('issuingCountry') });
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

	return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.documentType}>
        <CngCodeMasterAutocompleteField
          name={getFieldName("documentType")}
          label={aciHighwayManifestTranslationText.documentType}
          disabled={disabled}
          codeType='ACIHWY_DOCUMENT_TYPE'
          size='small'
          onChange={(value) => setValue(getFieldName("role"), value, { shouldDirty: true })}
          key={documentType}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.issuingCountry}>
        <CngCountryAutocompleteField
          required={personDocumentDTO ? documentType : false}
          name={getFieldName("issuingCountry")}
          label={aciHighwayManifestTranslationText.issuingCountry}
          disabled={disabled}
          lookupProps={{
            label: (record) => {
              return `${record.code};${record.descriptionEn}`
            }
          }}
          size='small'
          key={issuingCountry}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.documentNumber}>
        <CngTextField
          required={personDocumentDTO ? documentType : false}
          name={getFieldName("documentNumber")}
          label={aciHighwayManifestTranslationText.documentNumber}
          disabled={disabled}
          inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 80 }}
          onBlur={(e) => {
            setValue(getFieldName("documentNumber"), e.target.value.toUpperCase(), { shouldValidate: true })
          }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.expiryDate}>
        <CngDateField
          name={getFieldName("expiryDate")}
          label={aciHighwayManifestTranslationText.expiryDate}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
    </Grid>
	)
}

const PersonDocumentDTOFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default PersonDocumentDTOFormProperties
